import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaGlobe, FaBars, FaTimes, FaChevronLeft } from 'react-icons/fa';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  
  // Handle screen size changes
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    window.addEventListener('resize', handleResize);
    handleResize(); // Initial check
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  // Send a custom event when the sidebar toggle is clicked
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
    const event = new CustomEvent('toggle-sidebar');
    document.dispatchEvent(event);
  };

  return (
    <header className="w-full bg-black/90 border-b border-gray-800 relative">
      {/* Mobile sidebar toggle has been moved to App.tsx */}
      <div className="flex items-center justify-between px-4 py-3 md:py-4 md:px-8">
        {/* Logo with conditional left padding on mobile */}
        <Link to="/" className="flex items-center gap-2 ml-10">
          <img src="/TRUTH NEXUS.svg" alt="Truth Nexus Logo" className="h-16 w-auto" />
        </Link>
        {/* Desktop links */}
        <nav className="hidden md:flex items-center gap-6">
          <Link to="/about-us" className="text-white hover:text-truth font-medium transition-colors">About Us</Link>
          <Link to="/contact" className="text-white hover:text-truth font-medium transition-colors">Contact Us</Link>
        </nav>
        {/* Hamburger for top navigation menu */}
        <button
          className="md:hidden p-2 rounded text-white hover:bg-gray-800 focus:outline-none"
          onClick={() => setOpen(!open)}
          aria-label="Open menu"
        >
          {open ? <FaTimes className="h-6 w-6" /> : <FaBars className="h-6 w-6" />}
        </button>
      </div>
      {/* Mobile menu */}
      {open && (
        <nav className="md:hidden bg-black/95 border-t border-gray-800 px-4 py-4 flex flex-col gap-4">
          <Link to="/about-us" className="text-white hover:text-truth font-medium transition-colors" onClick={() => setOpen(false)}>About Us</Link>
          <Link to="/contact" className="text-white hover:text-truth font-medium transition-colors" onClick={() => setOpen(false)}>Contact Us</Link>
        </nav>
      )}
    </header>
  );
} 